const guiColors = {
    'motion-primary': 'hsla(260, 60%, 60%, 1)',
    'motion-primary-transparent': 'hsla(260, 60%, 60%, 0.9)',
    'motion-tertiary': 'hsla(260, 42%, 51%, 1)',

    'looks-secondary': 'hsla(260, 60%, 60%, 1)',
    'looks-secondary-light': 'hsla(260, 80%, 80%, 1)',
    'looks-secondary-lighter': 'hsla(260, 95%, 95%, 1)',
    'looks-transparent': 'hsla(260, 60%, 60%, 0.35)',
    'looks-light-transparent': 'hsla(260, 60%, 60%, 0.15)',
    'looks-secondary-dark': 'hsla(260, 42%, 52%, 1)',
    'looks-secondary-darker': 'hsl(260,30%,30%)',
    'looks-secondary-deep-dark': 'hsla(260, 10%, 10%, 1)',
	
	'drop-highlight': 'hsl(260,100%,82%)',
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
